(function () {
    'use strict';

    angular.module('app').factory('ExportLoyaltyService', ExportLoyaltyService);

    ExportLoyaltyService.$inject = ['$rootScope', 'API', '$http', 'LoyaltyService', '$q', 'NotifyService', '$translate'];

    function ExportLoyaltyService($rootScope, API, $http, LoyaltyService, $q, NotifyService, $translate) {
        var service = {};

        service.toExportSectionsDefault = [
            {
                section: 'main',
                title: 'Loyalty settings',
                included: true
            },
            {
                section: 'categories',
                title: 'Card categories',
                included: true
            },
            {
                section: 'categories_rules',
                title: 'Buyer category settings',
                included: true
            },
            {
                section: 'loyalty_rules',
                title: 'Loyalty rules',
                included: true
            },
            {
                section: 'referral_program',
                title: 'Referral program',
                included: true
            },
            {
                section: 'online_store',
                title: 'Loyalty Online Store',
                included: true
            },
            {
                section: 'pkpass',
                title: 'PKPASS',
                included: true
            },
            {
                section: 'additional_services',
                title: 'delivery_services_settings',
                included: true
            },
            {
                section: 'customers_messages',
                title: 'Message templates',
                included: true
            },
            {
                section: 'taxes',
                title: 'Loyalty taxes',
                included: true
            },
            {
                section: 'additional_costs',
                title: 'Loyalty additional costs',
                included: true
            },
            {
                section: 'settings',
                title: 'Additional settings',
                included: true
            },
            {
                section: 'external_data_access',
                title: 'External access',
                included: true
            }
        ]

        service.PrepareExportData = function (id, toExportSections, callback) {
            var exportSections = {};

            toExportSections = toExportSections.filter(function (value) {
                return value.included
            })

            for (var section of toExportSections) {
                switch (section.section) {
                    case "main":
                        section.url = `/loyalty/${id}`
                        break;
                    case "categories":
                        section.url = `/loyalty/${id}/card_categories`
                        break;
                    case "categories_rules":
                        section.url = `/loyalty/${id}/card_categories_rules`
                        break;
                    case "loyalty_rules":
                        section.url = `/loyalty/${id}/rules`
                        break;
                    case "referral_program":
                        section.url = `/loyalty/${id}/referral_program`
                        break;
                    case "online_store":
                        section.url = `/loyalty/${id}/online_store`
                        break;
                    case "pkpass":
                        section.url = `/loyalty/${id}/pkpass/settings`
                        break;
                    case "additional_services":
                        section.url = `/loyalty/${id}/additional_services`
                        break;
                    case "deliveries":
                        section.url = `/loyalty/${id}/deliveries`
                        break;
                    case "customers_messages":
                        section.url = `/loyalty/${id}/customers_messages`
                        break;
                    case "taxes":
                        section.url = `/loyalty/${id}/taxes`
                        break;
                    case "additional_costs":
                        section.url = `/loyalty/${id}/additional_costs`
                        break;
                    case "settings":
                        section.url = `/loyalty/${id}/settings`
                        break;
                    case "external_data_access":
                        section.url = `/loyalty/${id}/external_data_access`
                        break;
                }
            }

            var requestNumber = 0;
            var requestCount = toExportSections.length;

            var handleResults = function () {

                var nextRequest = function (section, result) {
                    exportSections[section] = result;

                    ++requestNumber;
                    if (requestNumber < requestCount) {
                        handleResults()
                        return
                    }
                    callback(true, exportSections)
                }

                API.get(toExportSections[requestNumber].url, function (success, result) {
                    if (success) {
                        switch (toExportSections[requestNumber].section) {
                            case 'categories':
                                result = result.filter(function (value) {
                                    return value.active;
                                });

                                if (result.length === 0 || !result) {
                                    nextRequest(toExportSections[requestNumber].section, [])
                                    return
                                }

                                var categories_count = result.length,
                                    categories_current_count = 0,
                                    categories = [];

                                var handleCategoriesExport = function (category) {
                                    LoyaltyService.GetCardCategories(id, category.id, function (categoriesSuccess, categoriesData) {
                                        ++categories_current_count;
                                        if (categoriesSuccess) {
                                            categories.push(categoriesData);
                                        }
                                        if (categories_current_count < categories_count) {
                                            handleCategoriesExport(result[categories_current_count])
                                            return;
                                        }
                                        nextRequest(toExportSections[requestNumber].section, categories)
                                    })
                                }
                                handleCategoriesExport(result[categories_current_count])
                                break;
                            case 'categories_rules':
                                result = result.filter(function (value) {
                                    return value.active;
                                });

                                if (result.length === 0 || !result) {
                                    nextRequest(toExportSections[requestNumber].section, [])
                                    return
                                }

                                var categories_rules_count = result.length,
                                    categories_rules_current_count = 0,
                                    categories_rules = [];

                                var handleCategoriesRulesExport = function (rule) {
                                    LoyaltyService.GetCardCategoriesRule(id, rule.id, function (categoryRulesSuccess, categoryRulesData) {
                                        ++categories_rules_current_count;
                                        if (categoryRulesSuccess) {
                                            categories_rules.push(categoryRulesData);
                                        }
                                        if (categories_rules_current_count < categories_rules_count) {
                                            handleCategoriesRulesExport(result[categories_rules_current_count])
                                            return;
                                        }
                                        nextRequest(toExportSections[requestNumber].section, categories_rules)
                                    })
                                }
                                handleCategoriesRulesExport(result[categories_rules_current_count])
                                break;
                            case 'loyalty_rules':
                                result = result.filter(function (value) {
                                    return value.active;
                                });

                                if (result.length === 0 || !result) {
                                    nextRequest(toExportSections[requestNumber].section, [])
                                    return
                                }

                                var loyalty_rules_count = result.length,
                                    loyalty_rules_current_count = 0,
                                    loyalty_rules = [];

                                var handleLoyaltyRulesExport = function (loyalty_rule) {
                                    LoyaltyService.GetLoyaltyRule(loyalty_rule.loyalty_id, loyalty_rule.id, function (ruleSuccess, ruleData) {
                                        ++loyalty_rules_current_count;
                                        if (ruleSuccess) {
                                            loyalty_rules.push(ruleData);
                                        }
                                        if (loyalty_rules_current_count < loyalty_rules_count) {
                                            handleLoyaltyRulesExport(result[loyalty_rules_current_count])
                                            return;
                                        }
                                        nextRequest(toExportSections[requestNumber].section, loyalty_rules)
                                    })
                                }
                                handleLoyaltyRulesExport(result[loyalty_rules_current_count])
                                break;
                            case 'deliveries':
                                result = result.filter(function (value) {
                                    return value.active;
                                });

                                if (result.length === 0 || !result) {
                                    nextRequest(toExportSections[requestNumber].section, [])
                                    return
                                }

                                var deliveries_count = result.length,
                                    deliveries_current_count = 0,
                                    deliveries = [];

                                var handleDeliveriesExport = function (delivery) {
                                    LoyaltyService.DeliveryServiceById(delivery.id, id, function (deliverySuccess, deliveryData) {
                                        ++deliveries_current_count;
                                        if (deliverySuccess) {
                                            deliveries.push(deliveryData);
                                        }
                                        if (deliveries_current_count < deliveries_count) {
                                            handleDeliveriesExport(result[deliveries_current_count])
                                            return;
                                        }
                                        nextRequest(toExportSections[requestNumber].section, deliveries)
                                    })
                                }
                                handleDeliveriesExport(result[deliveries_current_count])
                                break;
                            case 'additional_services':

                                if (result.length === 0 || !result) {
                                    nextRequest(toExportSections[requestNumber].section, [])
                                    return
                                }

                                var additional_services_count = result.length,
                                    additional_services_current_count = 0,
                                    services = [];

                                var handleAdditionalServicesExport = function (service) {
                                    LoyaltyService.DeliveryServiceById(service.id, id, function (serviceSuccess, serviceData) {
                                        ++additional_services_current_count;
                                        if (serviceSuccess) {
                                            services.push(serviceData);
                                        }
                                        if (additional_services_current_count < additional_services_count) {
                                            handleAdditionalServicesExport(result[additional_services_current_count])
                                            return;
                                        }
                                        nextRequest(toExportSections[requestNumber].section, services)
                                    })
                                }
                                handleAdditionalServicesExport(result[additional_services_current_count])
                                break;
                            default:
                                nextRequest(toExportSections[requestNumber].section, result);

                        }
                    }
                })
            }

            handleResults();
        }

        service.Export = function (id, toExportSections, callback) {
            if (!toExportSections) {
                toExportSections = service.toExportSectionsDefault
            }
            service.PrepareExportData(id, toExportSections, function (success, data) {
                callback(success, data)
            })
        }

        service.parseImportSections = function (json, callback) {
            var sections = Object.keys(json).map(function (item) {
                var defaultItem = service.toExportSectionsDefault.find(function (section) {
                    return section.section === item
                });
                return {
                    section: item,
                    title: defaultItem.title,
                    included: true
                }
            })
            callback(true, sections)
        }

        var handleCategories = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            var requestNumber = 0;
            var requestCount = data.length;

            var handleResults = function (category) {
                ++requestNumber;
                var post_data = {
                    active: category.active,
                    active_change_allowed: category.active_change_allowed,
                    notify_customers: category.notify_customers,
                    public_title: category.public_title,
                    show_to_customers: category.show_to_customers,
                    title: category.title,
                    title_change_allowed: category.title_change_allowed,
                    weight: category.weight,
                    weight_change_allowed: category.weight_change_allowed,
                };

                if (category.extended_settings) {
                    post_data.extended_settings = category.extended_settings
                }

                post_data = cleanRequestData(post_data);

                if (category.id) {
                    LoyaltyService.SaveCardCategories(loyaltyId, category.id, post_data, function (successUpdate, dataUpdate) {
                        if (!successUpdate) {
                            errors.push(`${dataUpdate.message} (${requestNumber})`);
                            if (requestNumber < requestCount) {
                                handleResults(data[requestNumber])
                                return;
                            }
                            callback(errors)
                            return;
                        }

                        if (!category.image) {
                            LoyaltyService.RemoveImageCardCategories(loyaltyId, category.id, function (image_success, image_data) {
                                if (!image_success) {
                                    var message = 'Cannot delete image'
                                    errors.push(`${message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                            return;
                        }

                        imgToDataUrl(category.image, function (img) {
                            if (!img) {
                                var message = 'Cannot load image'
                                errors.push(`${message} (${requestNumber})`)
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                                return;
                            }
                            LoyaltyService.UploadImageCardCategories(loyaltyId, category.id, img, function (image_success, image_data) {
                                if (!image_success) {
                                    var message = 'Cannot load image'
                                    errors.push(`${message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        })

                    })
                } else {
                    LoyaltyService.AddCardCategories(loyaltyId, post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }

                        if (!category.image || !successCreate) {
                            if (requestNumber < requestCount) {
                                handleResults(data[requestNumber])
                                return;
                            }
                            callback(errors);
                            return;
                        }

                        imgToDataUrl(category.image, function (img) {
                            if (!img) {
                                var message = 'Cannot load image'
                                errors.push(`${message} (${requestNumber})`)
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                                return;
                            }
                            LoyaltyService.UploadImageCardCategories(loyaltyId, dataCreate.id, img, function (image_success, image_data) {
                                if (!image_success) {
                                    var message = 'Cannot load image'
                                    errors.push(`${message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        })
                    })
                }
            }

            LoyaltyService.CardCategories(loyaltyId, function (categorieSsuccess, categoriesData) {
                if (categorieSsuccess) {
                    data.map(function (item) {
                        if (item.id && categoriesData.length > 0) {
                            var f = categoriesData.find(function (el) {
                                return el.id === item.id
                            })

                            if (!f && item.id) {
                                delete item.id;
                            }

                        } else {
                            if (item.id) {
                                delete item.id
                            }
                        }
                        return item;
                    })
                    handleResults(data[requestNumber])
                }
            })

        }

        var handleCategoryRule = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            var requestNumber = 0;
            var requestCount = data.length;

            var handleResults = function (rule) {
                ++requestNumber;
                var post_data = {
                    active: rule.active,
                    action_type: rule.action_type,
                    items_limit_min: rule.items_limit_min,
                    items_limit_max: rule.items_limit_max,
                    charge_type: rule.charge_type,
                    promotional_bonuses_starting_type: rule.promotional_bonuses_starting_type,
                    promotional_bonuses_expire_type: rule.promotional_bonuses_expire_type,
                    depends_type: rule.depends_type,
                    depends_calc_period: rule.depends_calc_period,
                    applicable_for_sale: rule.applicable_for_sale,
                    card_category_id: rule.card_category_id,
                    apply_when_bonuses_redeemed: rule.apply_when_bonuses_redeemed,
                    combine: rule.combine,
                    priority: rule.priority,
                    automatic: rule.automatic,
                    value: rule.value,
                    coupon_by_item_issue_quantity: rule.coupon_by_item_issue_quantity,
                    loyalty_id: loyaltyId,
                    time_from: rule.time_from,
                    time_to: rule.time_to,
                    applicable_for_customer: rule.applicable_for_customer,
                    promotional_bonuses_expire_value: rule.promotional_bonuses_expire_value,
                    promotional_bonuses_starting_value: rule.promotional_bonuses_starting_value,
                    promotional_bonuses_expire_date: rule.promotional_bonuses_expire_date,
                    promotional_bonuses_starting_date: rule.promotional_bonuses_starting_date
                };

                post_data = cleanRequestData(post_data);

                if (rule.id) {
                    LoyaltyService.GetCardCategoriesRule(loyaltyId, rule.id, function (success, getData) {
                        if (success) {
                            LoyaltyService.SaveCardCategoriesRule(loyaltyId, rule.id, post_data, function (successUpdate, dataUpdate) {
                                if (!successUpdate) {
                                    errors.push(`${dataUpdate.message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        }
                        if (!success) {
                            LoyaltyService.AddCardCategoriesRules(loyaltyId, post_data, function (successCreate, dataCreate) {
                                if (!successCreate) {
                                    errors.push(`${dataCreate.message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        }
                    })
                } else {
                    LoyaltyService.AddCardCategoriesRules(loyaltyId, post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }
                        if (requestNumber < requestCount) {
                            handleResults(data[requestNumber])
                            return;
                        }
                        callback(errors)
                    })
                }
            }

            LoyaltyService.GetCardCategoriesRules(loyaltyId, function (successRules, dataRules) {
                if (successRules) {
                    data.map(function (item) {
                        if (item.id && dataRules.length > 0) {
                            var f = dataRules.find(function (el) {
                                return el.id === item.id
                            })

                            if (!f && item.id) {
                                delete item.id;
                            }

                        } else {
                            if (item.id) {
                                delete item.id
                            }
                        }
                        return item;
                    })
                    handleResults(data[requestNumber])
                }
            })
        }

        var handleReferralProgram = function (loyaltyId, data, callback) {
            LoyaltyService.LoyaltyReferralProgramEdit(loyaltyId, data, function (success, data) {
                if (!success) {
                    callback([data.message])
                    return;
                }
                callback([])
            })

        }

        var handleTaxes = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            var createTaxes = function () {
                var requestNumber = 0;
                var requestCount = data.length;

                var handleResults = function (tax) {
                    ++requestNumber;
                    var post_data = {
                        classification: tax.classification,
                        decimal_digits: tax.decimal_digits,
                        default_value: tax.default_value,
                        include_in_receipt: tax.include_in_receipt,
                        title: tax.title,
                        type: tax.type,
                        used: tax.used
                    };

                    post_data = cleanRequestData(post_data);

                    LoyaltyService.AddTax(loyaltyId, post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }
                        if (requestNumber < requestCount) {
                            handleResults(data[requestNumber])
                            return;
                        }
                        callback(errors)
                    })
                }
                handleResults(data[requestNumber])
            }

            LoyaltyService.GetTaxes(loyaltyId, function (taxesSuccess, taxesData) {
                if (taxesSuccess) {
                    if (taxesData && taxesData.length === 0) {
                        createTaxes()
                        return;
                    }
                    var requestTaxesNumber = 0;
                    var requestTaxesCount = taxesData.length;

                    var handle = function (item) {
                        ++requestTaxesNumber;
                        LoyaltyService.DeleteTax(loyaltyId, item.id, function (successDelete, deleteData) {
                            if (requestTaxesNumber < requestTaxesCount) {
                                handle(taxesData[requestTaxesNumber])
                                return;
                            }
                            createTaxes()
                        })
                    }
                    handle(taxesData[requestTaxesNumber])
                }
            })
        }

        var handleAdditionalServices = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            var createServices = function () {
                var requestNumber = 0;
                var requestCount = data.length;

                var handleResults = function (service) {
                    ++requestNumber;
                    var post_data = {
                        code: service.code,
                        cost: service.cost,
                        default: service.default,
                        public_description: service.public_description,
                        public_title: service.public_title,
                        sort_order: service.sort_order,
                        title: service.title,
                        loyalty_id: loyaltyId,
                        type: service.type
                    };

                    post_data = cleanRequestData(post_data);

                    LoyaltyService.CreateDeliveryServiceType(post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }
                        if (requestNumber < requestCount) {
                            handleResults(data[requestNumber])
                            return;
                        }
                        callback(errors)
                    })
                }
                handleResults(data[requestNumber])
            }

            LoyaltyService.DeliveryServicesTypes(loyaltyId, function (successServices, dataServices) {
                if (successServices) {
                    if (dataServices && dataServices.length === 0) {
                        createServices()
                        return;
                    }
                    var requestServicesNumber = 0;
                    var requestServicesCount = dataServices.length;

                    var handle = function (item) {
                        ++requestServicesNumber;
                        LoyaltyService.removeDeliveryServiceById(item.id, loyaltyId, function (successDelete, deleteData) {
                            if (requestServicesNumber < requestServicesCount) {
                                handle(dataServices[requestServicesNumber])
                                return;
                            }
                            createServices()
                        })
                    }
                    handle(dataServices[requestServicesNumber])
                }
            })


        }

        var handleAdditionalCosts = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            var createCosts = function () {
                var requestNumber = 0;
                var requestCount = data.length;

                var handleResults = function (cost) {
                    ++requestNumber;
                    var post_data = {
                        decimal_digits: cost.decimal_digits,
                        default_value: cost.default_value,
                        include_in_receipt: cost.include_in_receipt,
                        title: cost.title,
                        type: cost.type,
                        used: cost.used
                    };

                    post_data = cleanRequestData(post_data);

                    LoyaltyService.AddAdditionalCosts(loyaltyId, post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }
                        if (requestNumber < requestCount) {
                            handleResults(data[requestNumber])
                            return;
                        }
                        callback(errors)
                    })
                }
                handleResults(data[requestNumber])
            }

            LoyaltyService.GetAdditionalCosts(loyaltyId, function (successCosts, dataCosts) {
                if (successCosts) {
                    if (dataCosts && dataCosts.length === 0) {
                        createCosts()
                        return;
                    }
                    var requestCostsNumber = 0;
                    var requestCostsCount = dataCosts.length;

                    var handle = function (item) {
                        ++requestCostsNumber;
                        LoyaltyService.DeleteAdditionalCosts(loyaltyId, item.id, function (successDelete, deleteData) {
                            if (requestCostsNumber < requestCostsCount) {
                                handle(dataCosts[requestCostsNumber])
                                return;
                            }
                            createCosts()
                        })
                    }
                    handle(dataCosts[requestCostsNumber])
                }
            })


        }

        var handleDeliveries = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            var requestNumber = 0;
            var requestCount = data.length;

            var handleResults = function (delivery) {
                ++requestNumber;
                var post_data = {
                    active: delivery.active,
                    additional_customer_info: delivery.active,
                    delivery_address_required: delivery.delivery_address_required,
                    delivery_date_required: delivery.delivery_date_required,
                    delivery_time_required: delivery.delivery_time_required,
                    price: delivery.price,
                    public_title: delivery.public_title,
                    title: delivery.title
                };

                post_data = cleanRequestData(post_data);

                if (delivery.id) {
                    LoyaltyService.GetDelivery(loyaltyId, delivery.id, function (success, getData) {
                        if (success) {
                            LoyaltyService.ChangeDeliveryType(loyaltyId, delivery.id, post_data, function (successUpdate, dataUpdate) {
                                if (!successUpdate) {
                                    errors.push(`${dataUpdate.message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        }
                        if (!success) {
                            LoyaltyService.CreateDeliveryType(loyaltyId, post_data, function (successCreate, dataCreate) {
                                if (!successCreate) {
                                    errors.push(`${dataCreate.message} (${requestNumber})`)
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        }
                    })
                } else {
                    LoyaltyService.CreateDeliveryType(loyaltyId, post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }
                        if (requestNumber < requestCount) {
                            handleResults(data[requestNumber])
                            return;
                        }
                        callback(errors)
                    })
                }
            }

            handleResults(data[requestNumber])
        }

        var handleExternalDataAccess = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }
            var createAccess = function () {
                var requestNumber = 0;
                var requestCount = data.length;

                var handleResults = function (item) {
                    ++requestNumber;
                    var post_data = {
                        api_key: item.api_key,
                        scope: item.scope,
                        title: item.title,
                    };

                    post_data = cleanRequestData(post_data);

                    LoyaltyService.AddExternalAccess(loyaltyId, post_data, function (successCreate, dataCreate) {
                        if (!successCreate) {
                            errors.push(`${dataCreate.message} (${requestNumber})`)
                        }
                        if (requestNumber < requestCount) {
                            handleResults(data[requestNumber])
                            return;
                        }
                        callback(errors)
                    })
                }
                handleResults(data[requestNumber])
            }

            LoyaltyService.GetExternalAccessList(loyaltyId, function (successAccess, dataAccess) {
                if (successAccess) {
                    if (dataAccess && dataAccess.length === 0) {
                        createAccess()
                        return;
                    }
                    var requestAccessNumber = 0;
                    var requestAccessCount = dataAccess.length;

                    var handle = function (item) {
                        ++requestAccessNumber;
                        LoyaltyService.RemoveExternalAccess(loyaltyId, item.id, function (successDelete, deleteData) {
                            if (requestAccessNumber < requestAccessCount) {
                                handle(dataAccess[requestAccessNumber])
                                return;
                            }
                            createAccess()
                        })
                    }
                    handle(dataAccess[requestAccessNumber])
                }
            })


        }

        var handleLoyaltyRules = function (loyaltyId, data, callback) {
            var errors = [];
            if (data.length === 0) {
                errors.push($translate.instant('No data set'))
                callback(errors)
                return
            }

            LoyaltyService.LoyaltyRules(loyaltyId, function (rulesSuccess, rulesData) {
                if (rulesSuccess) {
                    data.map(function (item) {
                        if (item.id && rulesData.length > 0) {
                            var f = rulesData.find(function (el) {
                                return el.id === item.id
                            })

                            if (!f && item.id) {
                                delete item.id;
                            }

                        } else {
                            if (item.id) {
                                delete item.id
                            }
                        }
                        return item;
                    })
                    var requestNumber = 0;
                    var requestCount = data.length;

                    var handleResults = function (rule) {
                        ++requestNumber;
                        var post_data = {
                            action_type: rule.action_type,
                            active: rule.active,
                            applicable_for_customer: rule.applicable_for_customer,
                            applicable_for_sale: rule.applicable_for_sale,
                            apply_when_bonuses_redeemed: rule.apply_when_bonuses_redeemed,
                            apply_when_customers_account_payment: rule.apply_when_customers_account_payment,
                            automatic: rule.automatic,
                            card_category_id: rule.card_category_id,
                            charge_type: rule.charge_type,
                            combine: rule.combine,
                            comment: rule.comment,
                            coupon_batch_code: rule.coupon_batch_code,
                            depends_calc_period: rule.depends_calc_period,
                            depends_type: rule.depends_type,
                            excluded_item_categories: rule.excluded_item_categories,
                            excluded_items: rule.excluded_items,
                            implementation_data: rule.implementation_data,
                            included_item_categories: rule.included_item_categories,
                            included_items: rule.included_items,
                            items_limit_max: rule.items_limit_max,
                            items_limit_min: rule.items_limit_min,
                            loyalty_id: loyaltyId,
                            pos: rule.pos,
                            priority: rule.priority,
                            promotional_bonuses_expire_date: rule.promotional_bonuses_expire_date,
                            promotional_bonuses_expire_type: rule.promotional_bonuses_expire_type,
                            promotional_bonuses_expire_value: rule.promotional_bonuses_expire_value,
                            promotional_bonuses_starting_date: rule.promotional_bonuses_starting_date,
                            promotional_bonuses_starting_type: rule.promotional_bonuses_starting_type,
                            promotional_bonuses_starting_value: rule.promotional_bonuses_starting_value,
                            scheduled: rule.scheduled,
                            special_account_id: rule.special_account_id,
                            time_from: rule.time_from,
                            time_to: rule.time_to,
                            title: rule.title,
                            valid_after: rule.valid_after,
                            valid_before: rule.valid_before,
                            value: rule.value,
                            week_days: rule.week_days
                        };

                        post_data = cleanRequestData(post_data);

                        if (rule.id) {
                            LoyaltyService.GetLoyaltyRule(rule.loyalty_id, rule.id, function (success, getData) {
                                if (success) {
                                    LoyaltyService.ChangeLoyaltyRule(rule.loyalty_id, rule.id, post_data, function (successUpdate, dataUpdate) {
                                        if (!successUpdate) {
                                            errors.push(`${dataUpdate.message} (${requestNumber})`);
                                        }
                                        if (requestNumber < requestCount) {
                                            handleResults(data[requestNumber])
                                            return;
                                        }
                                        callback(errors)
                                    })
                                }
                                if (!success) {
                                    LoyaltyService.CreateLoyaltyRule(loyaltyId, post_data, function (successCreate, dataCreate) {
                                        if (!successCreate) {
                                            errors.push(`${dataCreate.message} (${requestNumber})`);
                                        }
                                        if (requestNumber < requestCount) {
                                            handleResults(data[requestNumber])
                                            return;
                                        }
                                        callback(errors)
                                    })
                                }
                            })
                        } else {
                            LoyaltyService.CreateLoyaltyRule(loyaltyId, post_data, function (successCreate, dataCreate) {
                                if (!successCreate) {
                                    errors.push(`${dataCreate.message} (${requestNumber})`);
                                }
                                if (requestNumber < requestCount) {
                                    handleResults(data[requestNumber])
                                    return;
                                }
                                callback(errors)
                            })
                        }
                    }
                    handleResults(data[requestNumber])
                }
            })
        }

        var handleOnlineStore = function (loyaltyId, data, callback) {
            LoyaltyService.LoyaltyOnlineStoreEdit(loyaltyId, data, function (success, storeData) {
                if (!success) {
                    callback([storeData.message])
                    return;
                }
                callback([])
            })

        }

        var handlePkpass = function (loyaltyId, data, callback) {
            LoyaltyService.ChangePkpassSettings(loyaltyId, data, function (success, storeData) {
                if (!success) {
                    callback([storeData.message])
                    return;
                }
                callback([])
            })

        }

        var handleCustomersMessages = function (loyaltyId, data, callback) {
            LoyaltyService.updateMessageTemplates(loyaltyId, data, function (success, messagesData) {
                if (!success) {
                    callback([messagesData.message])
                    return;
                }
                callback([])
            })

        }
        var handleSettings = function (loyaltyId, data, callback) {
            LoyaltyService.LoyaltySettingsEdit(loyaltyId, data, function (success, messagesData) {
                if (!success) {
                    callback([messagesData.message])
                    return;
                }
                callback([])
            })

        }

        service.import = function (loyaltyId, importSections, data, callback) {
            var loyalty = null;
            var errors = [];
            LoyaltyService.Get(loyaltyId, function (success, loyaltyData) {
                if (!success) {
                    NotifyService.Error('Error', true);
                }
                loyalty = loyaltyData;

                if (!loyalty) {
                    return;
                }

                importSections = importSections.filter(function (value) {
                    return value.included
                })

                var requestNumber = 0;
                var requestCount = importSections.length;

                var onRequestCheck = function () {
                    ++requestNumber;
                    if (requestNumber < requestCount) {
                        handleResults(importSections[requestNumber], data[importSections[requestNumber].section])
                        return
                    }
                    callback(true, errors)
                }

                var handleResults = function (section, sectionData) {
                    switch (importSections[requestNumber].section) {
                        case "main":
                            if (sectionData.id) {
                                delete sectionData.id
                            }
                            LoyaltyService.Change(loyaltyId, sectionData, function (success, mainData) {
                                if (!success) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: [mainData.message]
                                    })
                                }
                                if (sectionData.photos && sectionData.photos.length > 0 && sectionData.photos[0].url) {
                                    imgToDataUrl(sectionData.photos[0].url, function (img) {
                                        console.log(44444, img)
                                        if (img) {
                                            LoyaltyService.UploadPhoto(loyaltyId, img, function (image_success, image_data) {
                                                if (!image_success) {
                                                    var message = 'Cannot load image'
                                                    errors.push({
                                                        section: importSections[requestNumber],
                                                        data: message
                                                    })
                                                }
                                                onRequestCheck()
                                            })
                                        } else {
                                            onRequestCheck()
                                        }
                                    })
                                } else {
                                    onRequestCheck()
                                }
                            })
                            break;
                        case "categories":
                            handleCategories(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "categories_rules":
                            handleCategoryRule(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "referral_program":
                            handleReferralProgram(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "loyalty_rules":
                            handleLoyaltyRules(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "online_store":
                            handleOnlineStore(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "pkpass":
                            handlePkpass(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "additional_services":
                            handleAdditionalServices(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "deliveries":
                            handleDeliveries(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "customers_messages":
                            handleCustomersMessages(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "taxes":
                            handleTaxes(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "additional_costs":
                            handleAdditionalCosts(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "settings":
                            handleSettings(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                        case "external_data_access":
                            handleExternalDataAccess(loyaltyId, sectionData, function (errorMessages) {
                                if (errorMessages.length > 0) {
                                    errors.push({
                                        section: importSections[requestNumber],
                                        data: errorMessages
                                    })
                                }
                                onRequestCheck()
                            })
                            break;
                    }
                }

                handleResults(importSections[requestNumber], data[importSections[requestNumber].section])
            })
        }

        return service;
    }

})();
